import { SxProps, Theme } from '@mui/material';

export const baseSx: SxProps<Theme> = {
    border: 'none',
    fontFamily: 'SegoeUI-Semibold',
    fontSize: '13px',
    height: '100%',
    '& .MuiDataGrid-main': {
        border: '1px solid #e9ecef',
    },
    '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#dce0e4 !important',
        '--DataGrid-containerBackground': '#dce0e4 !important',
        color: '#525a64',
    },
    '& .MuiDataGrid-columnHeader': {
        border: '1px solid #e9ecef',
    },
    '& .MuiDataGrid-columnHeaderTitleContainer, .MuiDataGrid-columnHeader:focus': {
        outline: 'none',
    },
    '& .MuiDataGrid-virtualScrollerContent': {
        color: '#888f96',
        willChange: 'transform',
    },
    '& .MuiDataGrid-virtualScroller': {
        willChange: 'scroll-position',
    },
    '& .MuiDataGrid-cell .MuiDataGrid-cellContent': {
        WebkitBoxOrient: 'vertical',
        display: '-webkit-box',
        WebkitLineClamp: 3,
    },
    '& .MuiDataGrid-cell--editing .MuiDataGrid-cellContent': {
        WebkitBoxOrient: 'unset',
        display: 'block',
        WebkitLineClamp: 'unset',
        overflow: 'visible',
    },
    '& .MuiDataGrid-cell.numeric-cell .MuiDataGrid-cellContent': {
        WebkitBoxOrient: 'unset',
        display: 'flex',
        WebkitLineClamp: 'unset',
        overflow: 'visible',
        alignItems: 'center',
        width: '100%',
    },
    '& .MuiInputBase-root': {
        color: '#888f96',
        fontFamily: 'SegoeUI-Semibold',
        fontSize: '13px',
    },
    '& .MuiDataGrid-overlayWrapper, .MuiDataGrid-overlayWrapperInner': {
        height: '50px !important',
    },
};

export const frozenCornerSx: SxProps<Theme> = {
    ...baseSx,
    '& .MuiDataGrid-virtualScroller': {
        overflow: 'hidden !important',
        willChange: 'auto',
    },
};

export const frozenColumnsSx: SxProps<Theme> = {
    ...baseSx,
    '& .MuiDataGrid-virtualScroller': {
        overflowX: 'hidden !important',
        overflowY: 'scroll !important',
        willChange: 'scroll-position',
    },
};

export const frozenRowsSx: SxProps<Theme> = {
    ...baseSx,
    '& .MuiDataGrid-virtualScroller': {
        overflowX: 'scroll !important',
        overflowY: 'hidden !important',
        willChange: 'scroll-position',
    },
};

export const mainGridSx: SxProps<Theme> = {
    ...baseSx,
    '& .MuiDataGrid-virtualScroller': {
        overflow: 'scroll !important',
        willChange: 'scroll-position',
    },
};
